<div class="base-search-container">
  <div
    class="basic-search"
    [ngClass]="{ 'full-border': !isDisplaySearchOptions }"
  >
    <span class="p-input-icon-left" *ngIf="showSearchGlobal">
      <i class="pi pi-search"></i>
      <input
        [placeholder]="placeholder"
        type="text"
        pInputText
        style="width: 330px"
        [formControl]="searchBy"
        (keydown)="onKeydown($event)"
        [maxlength]="maxlength"
      />
    </span>

    <p-dropdown
      *ngIf="isDisplaySearchOptions && showSearchGlobal"
      [options]="searchOptions"
      [(ngModel)]="selectedSearchOption"
      optionLabel="label"
      optionValue="value"
      [formControl]="filterBy"
      (keydown)="onKeydown($event)"
      name="global"
    >
      <ng-template pTemplate="selectedItem">
        {{ getLabelByValue(filterBy.value) | translate }}
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div>{{ option.label | translate }}</div>
      </ng-template>
    </p-dropdown>
    <app-base-button
      *ngIf="advanceSearch && advancedSearchToggleMode === 'button'"
      ngClass="ml-3"
      label="Advanced Filter"
      [rightIcon]="true"
      [iconName]="
        isCollapsedAdvancedFilter ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
      "
      [attr.aria-expanded]="!isCollapsedAdvancedFilter"
      [outlined]="true"
      (click)="isCollapsedAdvancedFilter = !isCollapsedAdvancedFilter"
    >
    </app-base-button>
  </div>
  <ng-content></ng-content>
  <button
    ngClass="p-2 mt-3"
    *ngIf="advanceSearch && advancedSearchToggleMode === 'text'"
    (click)="handleClearFilter()"
    pButton
    pRipple
    [icon]="
      isCollapsedAdvancedFilter ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
    "
    iconPos="right"
    [attr.aria-expanded]="!isCollapsedAdvancedFilter"
    type="button"
    [label]="'ADVANCED_FILTER' | translate"
    class="p-button-secondary p-button-text"
    (click)="isCollapsedAdvancedFilter = !isCollapsedAdvancedFilter"
  ></button>
  <div
    class="advanced-search surface-card border-round"
    [ngClass]="{
      'mt-4':
        isCollapsedAdvancedFilter && advancedSearchToggleMode === 'button',
      'mt-2': advancedSearchToggleMode === 'text'
    }"
    [collapse]="isCollapsedAdvancedFilter"
  >
    <div
      [ngClass]="{
        'p-4': true,
        'pt-2': hideTitle
      }"
    >
      <span *ngIf="!hideTitle" class="sub-header flex mb-2">{{
        'ADVANCED_SEARCH' | translate
      }}</span>
      <app-base-form [formConfig]="advancedSearchConfig"> </app-base-form>
      <div class="search-footer">
        <button
          *ngIf="onClearFilter"
          (click)="handleClearFilter()"
          pButton
          pRipple
          icon="pi pi pi-times"
          iconPos="right"
          type="button"
          label="Clear Filters"
          class="p-button-secondary p-button-text"
        ></button>
        <app-base-button
          label="Search"
          class="ml-auto"
          (click)="onSearchClick()"
        >
        </app-base-button>
      </div>
    </div>
  </div>
</div>
